import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { HaloLoaderService } from 'src/app/core/halo-loader/halo-loader.service';
import { HaloToastService } from 'src/app/core/halo-toast/halo-toast.service';
import { AmplitudeAnalyticsService } from 'src/app/core/services/amplitude-analytics.service';
import { FacilityObject } from 'src/app/core/services/facility.model';
import { FacilityService } from 'src/app/core/services/facility.service';
import { environment } from '../../../../environments/environment';
import { RootScopeDeclare } from '../../../core/rootscope-declare';
import { RootScopeService } from '../../../core/shared-service/root-scope.service';
import { CommonUtil } from '../../../core/Utils/common-util';
import { DeprecatedFeatureType } from '../../deprecated-banner/deprecated-banner.interface';
import { TransformShortenSerialNumberPipe } from '../../pipes/transform-shorten-serial-number.pipe';
import { DashboardService } from '../../services/dashboard.service';
import { equipmentDetailsObject } from '../../services/equipment.model';
import { EquipmentService } from '../../services/equipment.service';
import {
  heatmapAsset,
  HeatmapColumnObject,
  heatmapEquipment,
  HeatmapFloorListObject,
  HeatmapFloorObject,
  IHeatmap,
  IHeatMapAddDeleteEquipmentObject,
  IHeatMapAddDeleteObject,
  IHeatmapPopUpObject,
  IMoveEquipmentInputVO,
} from '../../services/heatmap.service.model';

declare let $: any;
@Component({
  selector: 'app-heatmap',
  templateUrl: './heatmap.component.html',
  styleUrls: ['./heatmap.component.css'],
})
export class HeatmapComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('heatMapTableScrollContainer', { static: true }) heatMapTableScrollContainerElem: ElementRef;
  @ViewChild('equipmentTypeListCntr', { static: true }) equipmentTypeListCntrElem: ElementRef;
  @ViewChild('deleteEquipment', { static: true }) deleteEquipmentElem: ElementRef;
  errorModal = false;
  updateNowPopupData = {
    title: this.commonUtil.translateText('REFRESH'),
    message: this.commonUtil.translateText('HEATMAP.GRID.REFRESH.ERROR.MSG'),
    isWarningPopup: false,
    isRefresh: true,
    ctaButtonLabel: 'Refresh',
    isSecondaryTextButton: false,
    hideSecondaryButton: true,
  };
  rootScopeData: RootScopeDeclare;
  mobileSelectedCellId: string;
  actionStatus = '';
  heatMapData: IHeatmap;
  currentFloor: any = [];
  cellWidth: number;
  cellCloneWidth: number;
  cellCloneHeight: number;
  cellHeight: number;
  tableWidth: number;
  tableHeight: number;
  currentFloorTotalCols: number;
  tableNewLeftPosition = 0;
  scrollAmount = 0;
  scrollSteps = 5;
  visibleCols: number;
  hasFullPermission = true;
  floorsList: HeatmapFloorListObject[];
  activeFloorIndex: number;
  floorNameList: Array<string> = [];
  dataCollectedDate: Date;
  currentRouterUrl: string;
  showNextBtn = false;
  showPrevBtn = false;
  heatMapPopupData: IHeatmapPopUpObject;
  showHeatMapPopup = false;
  //  showHeatMapFloorPopup = false;
  isFloorAdding = false;
  isRowAdding = false;
  isColAdding = false;
  selectedFloorId: number;
  pendingHeatmapEquipment: heatmapEquipment[];
  showPendingEqTypeList = false;
  showPendingEqList = false;
  menuTop = 200;
  menuLeft = 100;
  beakTop = 20;
  selectedRowId = 0;
  selectedColId = 0;
  sourceRowId = 0;
  sourceColId = 0;
  maxVisibleColPerFloor: number;
  isRightToLeftSlideRequired = false;
  eqListMainMenuHeight: number;
  eqListMainMenuWidth: number;
  deleteEqMenuHeight: number;
  deleteEqMenuWidth: number;
  highlightCell: boolean;
  selectedEquipmentType: heatmapEquipment;
  selectedRowIndex: number;
  selectedColIndex: number;
  isHeatmapDragStarted = false;
  cellLeft = 0;
  cellTop = 0;
  newCellLeft = 0;
  newCellTop = 0;
  initialMouseX: number;
  initialMouseY: number;
  currentMouseX: number;
  currentMouseY: number;
  droppableColIndex: number;
  droppableRowIndex: number;
  originalCellHeight: number;
  originalCellWidth: number;
  curElement: HTMLElement;
  targetRowId: number;
  targetColId: number;
  cloudBasePath: string;
  showDeleteCellRowId: number;
  showDeleteCellColId: number;
  draggedItemRowId: null | number;
  draggedItemColId: null | number;
  isHeatmapCellDragged: boolean;
  showDeleteEquipment: boolean;
  deleteFloorName: string;
  deleteFloorId: number;
  deletedFloorIndex = -1;
  renameFloorIndex: number;
  deleteRowTop: number;
  deleteRowHeight: number;
  deleteColLeft: number;
  deleteColWidth: number;
  rowIndexToDelete: number;
  colIndexToDelete: number;
  rowDeleteInProgress = false;
  colDeleteInProgress = false;
  showRowColDelete = false;
  selectedEqDetails: HeatmapColumnObject;
  selectedEqUsage: string | undefined;
  isConnectedEquipment = false;
  isDisconnectedEquipment = false;
  isIdleEquipment = false;
  isBeltNotification = false;
  isRotateNotification = false;
  beltNotificationURL: string | undefined;
  rotateNotificationURL: string | undefined;
  rotationSuggestedEquipment: string | undefined;
  showEqDetails = false;
  showLastUsedDef = false;
  viewHeatMapInFullView = false;
  allowedScrollAmount = 0;
  floorBtnCntrWidth: number;
  moveableFloorBtnCntrWidth: number;
  btnCntrLeft: number;
  floorBtnScrollAmount = 0;
  requiredSpacePerBtn: number;
  isFloorBtnVisible: Array<boolean> = [];
  totalVisibleBtnCount = 1;
  totalBtnCount = 1;
  showEqSubDetails_mobile: boolean;
  showEqDetails_mobile: boolean;
  showLastUsedTooltip: boolean;
  showPeakUseTooltip: boolean;
  isAllMachinesAdded = false;
  currentFacility: FacilityObject;
  toggle = false;
  activateCurrentClick = false;
  heatMapOffsetTop: number;
  isEmpty: string;
  deprecatedBannerTitle: string;
  deprecatedBannerDescription: string;
  deprecatedFeatureType = DeprecatedFeatureType.FeatureSupportUpdate;
  // subscriptions
  private sub = new Subscription();

  // strength
  private _strengthActivityId = 10001; //todo: move this to common file

  constructor(
    private rootScopeService: RootScopeService,
    private dashboardService: DashboardService,
    private router: Router,
    private commonUtil: CommonUtil,
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private _facilityService: FacilityService,
    private _equipmentService: EquipmentService,
    private _toast: HaloToastService,
    private loader: HaloLoaderService,
    private _amplitudeService: AmplitudeAnalyticsService
  ) {
    this.getRootScopeData();
    this.setDeprecatedFeatureBanner();
  }

  private setDeprecatedFeatureBanner(): void {
    this.deprecatedBannerTitle = this.commonUtil.translateText('DEPRECATED.FEATURES.BANNER.TITLE');
    this.deprecatedBannerDescription = this.commonUtil.translateText('DEPRECATED.FEATURES.BANNER.DESCRIPTION.HEATMAP');
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe((rootScopeData) => {
      this.rootScopeData = rootScopeData;
    });
  }

  ngOnInit() {
    if (this.router.url === '/dashboard/heatmap') {
      this.rootScopeData.pageName = 'heatmap';
    }
    this.cloudBasePath = environment.cloudBasePath;

    // subscript facility change / when facility change
    this.currentFacility = this._facilityService.selectedFacility();
    const _facilityOnChange = this._facilityService.selectedFacilitySource.subscribe((res) => {
      this.currentFacility = res;
      this.dashboardService.getHeatMapData();
    });
    this.sub.add(_facilityOnChange);

    const _heatMapDataOnChange = this.dashboardService.heatMapDataSource.subscribe((res) => {
      this.afterGetHeatMapData(res);
    });
    this.sub.add(_heatMapDataOnChange);

    if (this.currentFacility['facilityId']) {
      this.dashboardService.getHeatMapData();
    }

    this.rootScopeService.scrolled$.subscribe(() => {
      this.heatMapOffsetTop = $('#heatMapTableScrollContainer').offset()?.top + 73;
      if (
        !this.viewHeatMapInFullView &&
        this.selectedRowIndex >= 0 &&
        this.selectedColIndex >= 0 &&
        this.cellTop >= 0 &&
        this.cellLeft >= 0 &&
        this.cellWidth &&
        this.cellHeight
      ) {
        if (this.isEmpty === 'true') {
          this.positionPendingEquipmentListMenu(
            this.selectedColIndex,
            this.selectedRowIndex,
            this.cellTop,
            this.cellLeft,
            this.cellWidth,
            this.cellHeight
          );
        } else {
          this.positionDeleteEquipmentMenu(
            this.selectedColIndex,
            this.selectedRowIndex,
            this.cellTop,
            this.cellLeft,
            this.cellWidth,
            this.cellHeight
          );
        }
      }
    });
  }

  ngOnDestroy() {
    // distryo subscriber
    this.sub.unsubscribe();
  }

  afterGetHeatMapData(data: IHeatmap) {
    this.heatMapData = data;
    this.floorsList = this.heatMapData['floors'];
    this.setFloorNameList();
    // if only date available
    if (this.heatMapData.dataCollectedAt) {
      const timeStamp = parseInt(this.heatMapData.dataCollectedAt, 10);
      this.getDataCollectedDate(timeStamp);
    }
    this.changeFloor(0);
    this.enableScrollableFloorButtons();
  }

  enableScrollableFloorButtons() {
    const totalSpaceAvailForBtns = $('#heatMapBtnCntr').width();
    const addFloorBtnWidth = $('.addFloor').width();
    const addRowColBtnsWidth = $('.rightButtons').width();
    const availSpace = totalSpaceAvailForBtns - (addFloorBtnWidth + addRowColBtnsWidth);
    this.requiredSpacePerBtn = 110;
    this.totalBtnCount = this.floorNameList.length;
    this.totalVisibleBtnCount = this.totalBtnCount;
    do {
      if (this.requiredSpacePerBtn * this.totalVisibleBtnCount <= availSpace) {
        break;
      }
    } while (--this.totalVisibleBtnCount);
    this.floorBtnCntrWidth = this.requiredSpacePerBtn * this.totalVisibleBtnCount;
    this.moveableFloorBtnCntrWidth = this.requiredSpacePerBtn * this.totalBtnCount;
    this.allowedScrollAmount = this.totalBtnCount - this.totalVisibleBtnCount;
    this.floorBtnScrollAmount = 0;
    this.btnCntrLeft = 0;
    this.setVisibleFloorBtns();
  }

  showNextFloorBtn() {
    if (this.allowedScrollAmount > this.floorBtnScrollAmount) {
      this.floorBtnScrollAmount++;
      this.btnCntrLeft = this.floorBtnScrollAmount * this.requiredSpacePerBtn * -1;
    }
    this.setVisibleFloorBtns();
  }

  showPrevFloorBtn() {
    if (this.floorBtnScrollAmount > 0) {
      this.floorBtnScrollAmount--;
      this.btnCntrLeft = this.floorBtnScrollAmount * this.requiredSpacePerBtn * -1;
    }
    this.setVisibleFloorBtns();
  }

  setVisibleFloorBtns() {
    for (let i = 0; this.totalBtnCount > i; i++) {
      if (i >= this.floorBtnScrollAmount && i < this.totalVisibleBtnCount + this.floorBtnScrollAmount) {
        this.isFloorBtnVisible[i] = true;
      } else {
        this.isFloorBtnVisible[i] = false;
      }
    }
  }

  viewEntireHeatMap() {
    this.scrollAmount = 0;
    this.visibleCols = 50;
    this.viewHeatMapInFullView = true;
    $('#page-cntr').addClass('makePositionStatic');
    $('html, body').addClass('autoScroll');
    this.tableNewLeftPosition = 0;
    this.showPrevBtn = false;

    this.setHeatmapCellSize();
  }

  closeHeatMapFullView() {
    this.heatMapOffsetTop = 0;
    this.scrollAmount = 0;
    this.visibleCols = 20;
    this.viewHeatMapInFullView = false;
    $('#page-cntr').removeClass('makePositionStatic');
    $('html, body').removeClass('autoScroll');

    setTimeout(() => {
      this.resetHeatMapSizeAndPosition();
    }, 0);
  }

  @HostListener('window:resize', ['$event'])
  resetHeatMapSizeAndPosition() {
    this.setHeatmapCellSize();
    this.tableNewLeftPosition = 0;
    this.scrollAmount = 0;
    this.scrollSteps = 5;
    this.afterGetHeatMapData(this.heatMapData);
  }

  setFloorNameList() {
    if (this.floorsList) {
      this.floorNameList = this.floorsList.map((floor: { floorName: string }) => {
        return floor.floorName;
      });
    }
  }

  getDataCollectedDate(timeStamp: number) {
    const dateAndTime = new Date(timeStamp);
    // const dd = dateAndTime.getDate();
    // const mm = dateAndTime.getMonth();
    // const yy = dateAndTime
    //   .getFullYear()
    //   .toString()
    //   .substr(-2);
    // this.dataCollectedDate = mm + '/' + dd + '/' + yy;
    this.dataCollectedDate = dateAndTime;
  }

  heatMapPrevCols() {
    if (this.scrollAmount <= 0) {
      return false;
    }
    this.showNextBtn = true;
    //  this.scrollAmount--;

    this.scrollSteps = this.scrollAmount > 5 ? 5 : this.scrollAmount;
    this.tableNewLeftPosition = this.tableNewLeftPosition + this.cellWidth * this.scrollSteps;
    if (this.scrollAmount >= 5) {
      this.scrollAmount = this.scrollAmount - 5;
    } else {
      this.scrollAmount = 0;
    }
    if (this.scrollAmount === 0) {
      this.showPrevBtn = false;
    }

    return true;
  }

  heatMapNextCols() {
    if (this.scrollAmount + this.visibleCols >= this.currentFloorTotalCols) {
      return false;
    }
    this.showPrevBtn = true;
    //  this.scrollAmount++;

    if (this.currentFloorTotalCols - (this.scrollAmount + this.visibleCols) > 5) {
      this.scrollSteps = 5;
      this.scrollAmount = this.scrollAmount + 5;
    } else {
      this.scrollSteps = this.currentFloorTotalCols - (this.scrollAmount + this.visibleCols);
      this.scrollAmount = this.scrollAmount + this.currentFloorTotalCols - (this.scrollAmount + this.visibleCols);
    }

    this.tableNewLeftPosition = this.tableNewLeftPosition - this.cellWidth * this.scrollSteps;
    if (this.scrollAmount + this.visibleCols === this.currentFloorTotalCols) {
      this.showNextBtn = false;
    }

    return true;
  }

  changeFloor(ind: number) {
    this.scrollAmount = 0;
    this.tableNewLeftPosition = 0;
    this.activeFloorIndex = ind;
    this.selectedFloorId = this.floorsList[this.activeFloorIndex].floorId;
    this.maxVisibleColPerFloor =
      this.rootScopeData.deviceType === 'phone' || this.rootScopeData.deviceType === 'tablet' ? 8 : 20;
    this.currentFloor = this.floorsList[this.activeFloorIndex];
    this.currentFloorTotalCols = this.floorsList[this.activeFloorIndex].floorDetails[0].columns.length;
    this.visibleCols =
      this.currentFloorTotalCols > this.maxVisibleColPerFloor ? this.maxVisibleColPerFloor : this.currentFloorTotalCols;
    this.showNextBtn = this.currentFloorTotalCols > this.maxVisibleColPerFloor;
    this.showPrevBtn = false;
    this.setHeatmapCellSize();
  }

  setHeatmapCellSize() {
    const tableCntrWidth = this.heatMapTableScrollContainerElem.nativeElement.offsetWidth;
    const numberRows = this.floorsList[this.activeFloorIndex].floorDetails.length;
    this.cellWidth = tableCntrWidth / this.visibleCols;
    this.tableWidth = this.currentFloorTotalCols * this.cellWidth;

    this.setCellHeight(numberRows);
  }

  setCellHeight(numberRows: number) {
    let cellHeight = 51;
    const heatMpaContainerHeight = 510;
    if (numberRows <= 10) {
      cellHeight = heatMpaContainerHeight / numberRows;
      this.heatMapTableScrollContainerElem.nativeElement.style.height = heatMpaContainerHeight + 'px';
    } else {
      this.heatMapTableScrollContainerElem.nativeElement.style.height = cellHeight * numberRows + 'px';
    }
  }

  addFloor() {
    const existingFloorCount = this.floorsList.length;
    if (existingFloorCount >= 5) {
      this.heatMapPopupData = {
        title: 'OOPS',
        message: 'REACHED.MAXIMUM.FLOORS',
        ctaButtonLabel: 'OK',
        isCloseIconCallsCta: true,
        hideSecondaryButton: true,
      };
      this.showHeatMapPopup = true;
      return false;
    }

    let lastFloorId = this.floorsList[this.floorsList.length - 1].floorId;
    const newFloorId = ++lastFloorId;
    const newFloorName = this.commonUtil.replaceValueAsHTMLOnTranslatedText('FLOOR', [newFloorId + '']);

    const newFloorObject = {
      floorId: newFloorId,
      floorName: newFloorName,
      showFloorSpinner: false,
      floorDetails: [
        {
          columns: [
            { columnId: 1, isEmpty: 'true' },
            { columnId: 2, isEmpty: 'true' },
            { columnId: 3, isEmpty: 'true' },
            { columnId: 4, isEmpty: 'true' },
            { columnId: 5, isEmpty: 'true' },
            { columnId: 6, isEmpty: 'true' },
            { columnId: 7, isEmpty: 'true' },
            { columnId: 8, isEmpty: 'true' },
          ],
          rowId: 1,
        },
        {
          columns: [
            { columnId: 1, isEmpty: 'true' },
            { columnId: 2, isEmpty: 'true' },
            { columnId: 3, isEmpty: 'true' },
            { columnId: 4, isEmpty: 'true' },
            { columnId: 5, isEmpty: 'true' },
            { columnId: 6, isEmpty: 'true' },
            { columnId: 7, isEmpty: 'true' },
            { columnId: 8, isEmpty: 'true' },
          ],
          rowId: 2,
        },
        {
          columns: [
            { columnId: 1, isEmpty: 'true' },
            { columnId: 2, isEmpty: 'true' },
            { columnId: 3, isEmpty: 'true' },
            { columnId: 4, isEmpty: 'true' },
            { columnId: 5, isEmpty: 'true' },
            { columnId: 6, isEmpty: 'true' },
            { columnId: 7, isEmpty: 'true' },
            { columnId: 8, isEmpty: 'true' },
          ],
          rowId: 3,
        },
        {
          columns: [
            { columnId: 1, isEmpty: 'true' },
            { columnId: 2, isEmpty: 'true' },
            { columnId: 3, isEmpty: 'true' },
            { columnId: 4, isEmpty: 'true' },
            { columnId: 5, isEmpty: 'true' },
            { columnId: 6, isEmpty: 'true' },
            { columnId: 7, isEmpty: 'true' },
            { columnId: 8, isEmpty: 'true' },
          ],
          rowId: 4,
        },
        {
          columns: [
            { columnId: 1, isEmpty: 'true' },
            { columnId: 2, isEmpty: 'true' },
            { columnId: 3, isEmpty: 'true' },
            { columnId: 4, isEmpty: 'true' },
            { columnId: 5, isEmpty: 'true' },
            { columnId: 6, isEmpty: 'true' },
            { columnId: 7, isEmpty: 'true' },
            { columnId: 8, isEmpty: 'true' },
          ],
          rowId: 5,
        },
        {
          columns: [
            { columnId: 1, isEmpty: 'true' },
            { columnId: 2, isEmpty: 'true' },
            { columnId: 3, isEmpty: 'true' },
            { columnId: 4, isEmpty: 'true' },
            { columnId: 5, isEmpty: 'true' },
            { columnId: 6, isEmpty: 'true' },
            { columnId: 7, isEmpty: 'true' },
            { columnId: 8, isEmpty: 'true' },
          ],
          rowId: 6,
        },
        {
          columns: [
            { columnId: 1, isEmpty: 'true' },
            { columnId: 2, isEmpty: 'true' },
            { columnId: 3, isEmpty: 'true' },
            { columnId: 4, isEmpty: 'true' },
            { columnId: 5, isEmpty: 'true' },
            { columnId: 6, isEmpty: 'true' },
            { columnId: 7, isEmpty: 'true' },
            { columnId: 8, isEmpty: 'true' },
          ],
          rowId: 7,
        },
        {
          columns: [
            { columnId: 1, isEmpty: 'true' },
            { columnId: 2, isEmpty: 'true' },
            { columnId: 3, isEmpty: 'true' },
            { columnId: 4, isEmpty: 'true' },
            { columnId: 5, isEmpty: 'true' },
            { columnId: 6, isEmpty: 'true' },
            { columnId: 7, isEmpty: 'true' },
            { columnId: 8, isEmpty: 'true' },
          ],
          rowId: 8,
        },
      ],
    };

    const inputJson = {
      facilityId: this.currentFacility.facilityId,
      floorId: newFloorId,
      floorName: newFloorName,
    };
    /*const inputJson: any = {};
    inputJson.facilityId = this.currentFacility.facilityId;
    inputJson.floorId = newFloorId;
    inputJson.floorName = newFloorName;*/

    this.isFloorAdding = true;

    this._amplitudeService.logEvent({ elementName: 'Add Floor', action: 'Click' }, 'Heatmap');
    this.dashboardService.saveHeatMapGridInfo(inputJson).subscribe(
      (data) => {
        this.floorsList.push(newFloorObject);
        this.changeFloor(existingFloorCount);
        this.setFloorNameList();
        this.heatMapPopupData = {
          title: 'NEW.FACILITY.FLOOR',
          message: 'NEW.FACILITY.FLOOR.MSG',
          ctaButtonLabel: 'OK',
          isCloseIconCallsCta: true,
          hideSecondaryButton: true,
        };
        this.showHeatMapPopup = true;
        this.isFloorAdding = false;
        this.enableScrollableFloorButtons();
      },
      (error) => {
        console.error('API failed.');
        this.isFloorAdding = false;
      }
    );

    return true;
  }

  addHeatMapRow() {
    // code needs to be added to avoid more than one immediate clicks and adding row while delet in progress

    const numberRows = this.floorsList[this.activeFloorIndex].floorDetails.length;
    if (numberRows === 50) {
      this.heatMapPopupData = {
        title: 'OOPS',
        message: 'REACHED.MAXIMUM.ROWS',
        ctaButtonLabel: 'OK',
        isCloseIconCallsCta: true,
        hideSecondaryButton: true,
      };
      this.showHeatMapPopup = true;
      return false;
    }
    const cols = this.floorsList[this.activeFloorIndex].floorDetails[0].columns;
    const lastRowId = this.floorsList[this.activeFloorIndex].floorDetails[numberRows - 1].rowId;
    const newRow: HeatmapFloorObject = { columns: [], rowId: lastRowId + 1 };
    for (let i = 0; cols.length > i; i++) {
      newRow.columns[i] = { columnId: cols[i].columnId, isEmpty: 'true' };
    }
    this.floorsList[this.activeFloorIndex].floorDetails.push(newRow);
    if (this.floorsList[this.activeFloorIndex].floorDetails.length < 10) {
      this.setCellHeight(this.floorsList[this.activeFloorIndex].floorDetails.length + 1);
    } else {
      this.setCellHeight(this.floorsList[this.activeFloorIndex].floorDetails.length);
    }
    this.saveNewRow();

    return true;
  }

  saveNewRow() {
    // save new row service should be integrated
    const inputJson: IHeatMapAddDeleteObject = {
      facilityId: this.currentFacility.facilityId,
      floorId: this.selectedFloorId,
      isRow: true,
    };
    this.isRowAdding = true;
    this._amplitudeService.logEvent({ elementName: 'Add Row', action: 'Click' }, 'Heatmap');
    this.dashboardService.saveHeatMapGridInfo(inputJson).subscribe(
      (data) => {
        this.isRowAdding = false;
      },
      (error) => {
        console.error('API failed.');
        this.isRowAdding = false;
      }
    );
  }

  addHeatMapCol() {
    const numberOfCols = this.floorsList[this.activeFloorIndex].floorDetails[0].columns.length;
    const maxCols = 50;
    if (numberOfCols === maxCols) {
      /* $scope.popupTitle = $scope.translateText('OOPS');
			$scope.popupMessage = $scope.translateText('REACHED.MAXIMUM.COLUMNS');
      $scope.heatMapInfoPopup = true;*/
      this.heatMapPopupData = {
        title: 'OOPS',
        message: 'REACHED.MAXIMUM.COLUMNS',
        ctaButtonLabel: 'OK',
        isCloseIconCallsCta: true,
        hideSecondaryButton: true,
      };
      this.showHeatMapPopup = true;
      return false;
    }
    const lastcolIndex = this.floorsList[this.activeFloorIndex].floorDetails[0].columns.length - 1;
    const lastColId = this.floorsList[this.activeFloorIndex].floorDetails[0].columns[lastcolIndex].columnId;
    for (let i = 0; i < this.floorsList[this.activeFloorIndex].floorDetails.length; i++) {
      const newCell = { columnId: parseInt(lastColId.toString(), 10) + 1, isEmpty: 'true' };
      this.floorsList[this.activeFloorIndex].floorDetails[i].columns.push(newCell);
    }
    //  $scope.isItNewCol = true;
    this.saveNewCol();
    return true;
  }

  saveNewCol() {
    // save new col service should be integrated
    const inputJson: IHeatMapAddDeleteObject = {
      facilityId: this.currentFacility.facilityId,
      floorId: this.selectedFloorId,
      isColumn: true,
    };
    this.isColAdding = true;
    this._amplitudeService.logEvent({ elementName: 'Add Column', action: 'Click' }, 'Heatmap');
    this.dashboardService.saveHeatMapGridInfo(inputJson).subscribe(
      (data) => {
        this.isColAdding = false;
        // $scope.isItNewCol = false;
        this.showLastCol();
      },
      (error) => {
        console.error('API failed.');
        this.isColAdding = false;
      }
    );
  }

  showLastCol() {
    this.maxVisibleColPerFloor =
      this.rootScopeData.deviceType === 'phone' || this.rootScopeData.deviceType === 'tablet' ? 8 : 20;
    this.currentFloorTotalCols = this.floorsList[this.activeFloorIndex].floorDetails[0].columns.length;
    this.visibleCols =
      this.currentFloorTotalCols > this.maxVisibleColPerFloor ? this.maxVisibleColPerFloor : this.currentFloorTotalCols;
    if (this.currentFloorTotalCols > this.maxVisibleColPerFloor && !this.viewHeatMapInFullView) {
      this.showNextBtn = false;
      this.showPrevBtn = true;
      this.scrollAmount = this.currentFloorTotalCols - this.maxVisibleColPerFloor - 1;
      this.tableNewLeftPosition = 0;
      this.tableNewLeftPosition = this.tableNewLeftPosition - this.cellWidth * this.scrollAmount;
      this.heatMapNextCols();
    } else {
      this.setHeatmapCellSize();
    }
  }

  showDeleteOrEquipmentList(
    event: MouseEvent,
    colIndex: number,
    rowIndex: number,
    cellObj: { columnId: number; isEmpty: string },
    rowId: number
  ) {
    this.showEqDetails = false;
    if (this.draggedItemRowId == rowId && this.draggedItemColId == cellObj.columnId) {
      //$("#addedEqDetailsCntr, #DeleteEquipment").addClass("hide");
      this.showPendingEqTypeList = false;
      this.showDeleteEquipment = false;
      return false;
    }
    this.selectedRowId = rowId;
    this.selectedColId = cellObj.columnId;
    this.selectedRowIndex = rowIndex;
    this.selectedColIndex = colIndex;
    this.highlightCell = false;
    this.isEmpty = cellObj.isEmpty;
    if (cellObj.isEmpty === 'true') {
      this.highlightCell = true;
      this.showPendingEquipmentList(event, colIndex, rowIndex, this.selectedColId, rowId);
      this.hideDeleteMenu();
    } else {
      this.showDeleteCellRowId = rowId;
      this.showDeleteCellColId = cellObj.columnId;
      this.showDeleteEquipmentOrBlock(event, colIndex, rowIndex, this.selectedColId, rowId);
      this.hidePendingEqList();
    }
    const cloneEle = (<HTMLElement>event.currentTarget).querySelector('.clone');
    if (cloneEle) {
      cloneEle.classList.remove('show');
    }
    event.stopPropagation();
    return true;
  }

  showDeleteEquipmentOrBlock(event: MouseEvent, colIndex: number, rowIndex: number, colId: number, rowId: number) {
    const el = <HTMLElement>event.currentTarget;
    this.cellTop = el.offsetTop;
    this.cellLeft = el.offsetLeft;
    this.cellWidth = el.offsetWidth;
    this.cellHeight = el.offsetHeight;
    this.positionDeleteEquipmentMenu(colIndex, rowIndex, this.cellTop, this.cellLeft, this.cellWidth, this.cellHeight);
    this.showDeleteEquipment = true;
  }

  positionDeleteEquipmentMenu(
    colIndex: number,
    rowIndex: number,
    cellTop: number,
    cellLeft: number,
    cellWidth: number,
    cellHeight: number
  ) {
    const totalRowsInHeatMap = this.floorsList[this.activeFloorIndex].floorDetails.length;
    const totalColsInHeatMap = this.floorsList[this.activeFloorIndex].floorDetails[0].columns.length;
    const totalVisibleCols =
      totalColsInHeatMap > this.maxVisibleColPerFloor ? this.maxVisibleColPerFloor : totalColsInHeatMap;
    let leftSpacing = 350;

    if (!this.heatMapOffsetTop) {
      this.heatMapOffsetTop = $('#heatMapTableScrollContainer').offset().top + 73;
    }

    if (this.viewHeatMapInFullView) {
      this.heatMapOffsetTop = $('#heatMapTableScrollContainer').offset().top;
      leftSpacing = 60;
    }
    this.deleteEqMenuHeight = 123;
    this.deleteEqMenuWidth = 204;
    const visibleColIndex = colIndex - this.scrollAmount;
    if (Math.ceil(totalVisibleCols / 2) > visibleColIndex && Math.ceil(totalRowsInHeatMap / 2) > rowIndex) {
      // cell is in left top
      if (!this.viewHeatMapInFullView) {
        this.menuTop = cellTop + this.heatMapOffsetTop - 80;
      } else {
        this.menuTop = cellTop + this.heatMapOffsetTop;
      }
      this.menuLeft = cellLeft + leftSpacing + cellWidth * 0.5;
      this.beakTop = 20;
      this.isRightToLeftSlideRequired = false;
    } else if (Math.ceil(totalVisibleCols / 2) <= visibleColIndex && Math.ceil(totalRowsInHeatMap / 2) > rowIndex) {
      // cell is in right top
      this.menuTop = cellTop + this.heatMapOffsetTop;
      this.menuLeft = cellLeft + leftSpacing - this.deleteEqMenuWidth + cellWidth * 0.5;
      this.beakTop = 20;
      this.isRightToLeftSlideRequired = true;
    } else if (Math.ceil(totalVisibleCols / 2) > visibleColIndex && Math.ceil(totalRowsInHeatMap / 2) <= rowIndex) {
      // cell is in left bottom
      if (!this.viewHeatMapInFullView) {
        this.menuTop = cellTop + this.heatMapOffsetTop - 80;
      } else {
        this.menuTop = cellTop + this.heatMapOffsetTop;
      }
      this.menuLeft = cellLeft + leftSpacing + cellWidth * 0.5;
      this.isRightToLeftSlideRequired = false;
      this.beakTop = this.deleteEqMenuHeight - 40;
    } else if (Math.ceil(totalVisibleCols / 2) <= visibleColIndex && Math.ceil(totalRowsInHeatMap / 2) <= rowIndex) {
      // cell is in right bottom
      this.menuTop = cellTop + this.heatMapOffsetTop;
      this.menuLeft = cellLeft + leftSpacing - this.deleteEqMenuWidth + cellWidth * 0.5;
      this.isRightToLeftSlideRequired = true;
      this.beakTop = this.deleteEqMenuHeight - 40;
    }
    this.menuLeft = this.menuLeft - cellWidth * this.scrollAmount;
  }

  deleteEquipmentFromHeatMap() {
    const inputJson: IHeatMapAddDeleteEquipmentObject = {
      facilityId: this.currentFacility.facilityId,
      floorId: this.selectedFloorId,
      rowId: this.selectedRowId,
      columnId: this.selectedColId,
    };
    this.loader.startProcess();
    this._amplitudeService.logEvent({ elementName: 'Delete Equipment', action: 'Click' }, 'Heatmap');
    this.dashboardService.deleteEquipment(inputJson).subscribe(
      (data) => {
        const selectedColumnObjForDelete: HeatmapColumnObject = {
          columnId: this.selectedColId,
          isBlock: 'false',
          isDataCollected: 'false',
          isEmpty: 'true',
          legend: '',
          icon: '',
        };
        this.loader.endProcess();
        this.floorsList[this.activeFloorIndex].floorDetails[this.selectedRowIndex].columns[this.selectedColIndex] =
          selectedColumnObjForDelete;
      },
      (error) => {
        this.loader.endProcess();
        console.error('API failed.');
      }
    );
  }

  showPendingEquipmentList(event: MouseEvent, colIndex: number, rowIndex: number, colId: number, rowId: number) {
    const el = <HTMLElement>event.target;
    this.cellTop = el.offsetTop;
    this.cellLeft = el.offsetLeft;
    this.cellWidth = el.offsetWidth;
    this.cellHeight = el.offsetHeight;
    // const currentCell =  e.target;
    this.showPendingEqTypeList = true;
    this.dashboardService.getPendingHeatMapAssets(this.currentFacility.facilityId).subscribe(
      (data) => {
        this.getHeatmapEquipment(data);
        this.showPendingEqTypeList = true;
        setTimeout(() => {
          if (!this.showEqDetails) {
            this.positionPendingEquipmentListMenu(
              colIndex,
              rowIndex,
              this.cellTop,
              this.cellLeft,
              this.cellWidth,
              this.cellHeight
            );
          } else {
            this.hideDeleteMenu();
            this.hidePendingEqList();
          }
        }, 0);
      },
      (error) => {
        console.error('API failed.');
      }
    );
  }

  private getHeatmapEquipment(data: any) {
    if (data) {
      this.pendingHeatmapEquipment = [];
      data.equipmentDetails?.forEach((eq: equipmentDetailsObject) => {
        const assets: heatmapAsset[] = [];
        eq.assetDetails?.forEach((asset) => {
          assets.push({
            name: asset.name,
            id: asset.id.toString(),
            activityId: asset.activityId,
            bodySerial: asset.bodySerial,
            displaySerial: asset.displayBodySerial ? asset.displayBodySerial : asset.bodySerial,
            consoleType: asset.consoleType,
            assetId: asset.assetId,
            nameEditable: false,
            equipmentType: 'cardio',
            equipmentModel: '',
            facilityId: this.currentFacility['facilityId'],
            originalName: asset.name ? asset.name : '',
          });
        });
        this.pendingHeatmapEquipment.push({
          activityId: eq.activityId,
          isAllMachinesAdded: eq.isAllMachinesAdded,
          assets: assets,
          resourceId: eq.activityId.toString(),
          machineModelDescription: '',
        });
      });

      data.connectedStrengthEquipmentDetailsByMachineModels?.forEach((eq: any) => {
        const assets: heatmapAsset[] = [];
        eq.connectedStrengthAssetDetailsVOList
          ?.filter((e: any) => e.equipmentSerialNumber)
          .forEach((asset: any) => {
            assets.push({
              name: asset.nickName,
              id: asset.assetId,
              activityId: eq.activityId,
              bodySerial: asset.equipmentSerialNumber,
              displaySerial: new TransformShortenSerialNumberPipe().transform(asset.equipmentSerialNumber),
              consoleType: '',
              machineModelId: asset.machineModelId,
              assetId: asset.assetId,
              nameEditable: false,
              equipmentType: 'strength',
              equipmentModel: '',
              facilityId: this.currentFacility['facilityId'],
              originalName: asset.nickName ? asset.nickName : '',
            });
          });
        this.pendingHeatmapEquipment.push({
          activityId: eq.activityId,
          isAllMachinesAdded: eq.isAllMachinesAdded,
          assets: assets,
          resourceId: `${eq.activityId}${eq.machineModelId}`,
          machineModelDescription: eq.connectedStrengthAssetDetailsVOList
            ? eq.connectedStrengthAssetDetailsVOList[0].machineModelDescription
            : '',
        });
      });
    }
  }

  positionPendingEquipmentListMenu(
    colIndex: number,
    rowIndex: number,
    cellTop: number,
    cellLeft: number,
    cellWidth: number,
    cellHeight: number
  ) {
    const totalRowsInHeatMap = this.floorsList[this.activeFloorIndex].floorDetails.length;
    const totalColsInHeatMap = this.floorsList[this.activeFloorIndex].floorDetails[0].columns.length;
    let leftSpacing = 350;
    const totalVisibleCols =
      totalColsInHeatMap > this.maxVisibleColPerFloor ? this.maxVisibleColPerFloor : totalColsInHeatMap;

    this.eqListMainMenuHeight = this.equipmentTypeListCntrElem.nativeElement.offsetHeight;
    this.eqListMainMenuWidth = this.equipmentTypeListCntrElem.nativeElement.offsetWidth;
    const visibleColIndex = colIndex - this.scrollAmount;

    if (!this.heatMapOffsetTop) {
      this.heatMapOffsetTop = $('#heatMapTableScrollContainer').offset().top + 73;
    }
    if (this.viewHeatMapInFullView) {
      this.heatMapOffsetTop = $('#heatMapTableScrollContainer').offset().top;
      leftSpacing = 60;
    }
    if (Math.ceil(totalVisibleCols / 2) > visibleColIndex && Math.ceil(totalRowsInHeatMap / 2) > rowIndex) {
      // cell is in left top
      this.menuTop = cellTop + this.heatMapOffsetTop;
      this.menuLeft = cellLeft + leftSpacing + cellWidth * 0.5;
      this.beakTop = 20;
      this.isRightToLeftSlideRequired = false;
    } else if (Math.ceil(totalVisibleCols / 2) <= visibleColIndex && Math.ceil(totalRowsInHeatMap / 2) > rowIndex) {
      // cell is in right top
      this.menuTop = cellTop + this.heatMapOffsetTop;
      this.menuLeft = cellLeft + leftSpacing - this.eqListMainMenuWidth + cellWidth * 0.5;
      this.beakTop = 20;
      this.isRightToLeftSlideRequired = true;
    } else if (Math.ceil(totalVisibleCols / 2) > visibleColIndex && Math.ceil(totalRowsInHeatMap / 2) <= rowIndex) {
      // cell is in left bottom
      this.menuTop = cellTop + this.heatMapOffsetTop - this.eqListMainMenuHeight + cellHeight;
      this.menuLeft = cellLeft + leftSpacing + cellWidth * 0.5;
      this.isRightToLeftSlideRequired = false;
      this.beakTop = this.eqListMainMenuHeight - 40;
    } else if (Math.ceil(totalVisibleCols / 2) <= visibleColIndex && Math.ceil(totalRowsInHeatMap / 2) <= rowIndex) {
      // cell is in right bottom
      this.menuTop = cellTop + this.heatMapOffsetTop - this.eqListMainMenuHeight + cellHeight;
      this.menuLeft = cellLeft + leftSpacing - this.eqListMainMenuWidth + cellWidth * 0.5;
      this.isRightToLeftSlideRequired = true;
      this.beakTop = this.eqListMainMenuHeight - 40;
    }
    this.menuLeft = this.menuLeft - cellWidth * this.scrollAmount;
  }

  displayEquipment(pendingEqTypeObj: heatmapEquipment) {
    if (pendingEqTypeObj.isAllMachinesAdded == 'true') {
      return false;
    }
    this.showPendingEqList = true;
    this.selectedEquipmentType = pendingEqTypeObj;

    this.highLightEqType();

    const equipmentListCntrRef = this.elementRef.nativeElement.querySelector('.equipmentListCntr');
    if (equipmentListCntrRef) equipmentListCntrRef.classList.add('visible');
    return true;
  }

  @HostListener('document:click', ['$event'])
  hidePendingEqListOrDeleteMenu(event: MouseEvent) {
    this.hidePendingEqList();
    this.hideDeleteMenu();
    this.hideLastUsedMsg();
    this.hidePeakUseMsg();
  }

  hidePendingEqList() {
    this.showPendingEqList = false;
    this.showPendingEqTypeList = false;
    this.highlightCell = false;
  }

  hideDeleteMenu() {
    this.showDeleteEquipment = false;
  }

  changeBgColorAndHideEquimentSubMenu() {
    this.highLightEqType();
    this.showPendingEqList = false;
  }

  highLightEqType() {
    const pendingEqRows = this.elementRef.nativeElement.querySelectorAll('.pendingEquipmentTypeRow:not(.disabled)');
    for (let i = 0; i < pendingEqRows.length; i++) {
      pendingEqRows[i].classList.remove('highlightGray');
    }
    // Jeya commented this because there is no "event" on this component.
    // this.renderer.addClass(event.currentTarget, 'highlightGray');
  }

  hideMenuAndShowPopup(val: string) {
    setTimeout(() => {
      this.hidePendingEqList();
      if (val === 'true') {
        this.isAllMachinesAdded = true;
      }
    }, 1000);
  }

  addEmptyBlockToHeatMap(event: { stopPropagation: () => void }) {
    event.stopPropagation();
    //call add equipment service
    const inputJson: IHeatMapAddDeleteEquipmentObject = {
      facilityId: this.currentFacility.facilityId,
      floorId: this.selectedFloorId,
      rowId: this.selectedRowId,
      columnId: this.selectedColId,
      isBlock: 'true',
    };
    this._amplitudeService.logEvent({ elementName: 'Add Empty Equipment', action: 'Click' }, 'Heatmap');
    this.dashboardService.addEquipment(inputJson).subscribe(
      (data) => {
        const newBlockObject = {
          columnId: this.selectedColId,
          isBlock: 'true',
          isDataCollected: 'false',
          isEmpty: 'false',
          legend: '',
          icon: 'block_Icon',
        };
        this.floorsList[this.activeFloorIndex].floorDetails[this.selectedRowIndex].columns[this.selectedColIndex] =
          newBlockObject;
        this.showPendingEqTypeList = false;
        this.highlightCell = false;
      },
      (error) => {
        console.error('API failed.');
      }
    );
  }

  heatMapDragStart(event: DragEvent, colIndex: number, rowIndex: number) {
    this.activateCurrentClick = true;
    if (this.rootScopeData.deviceType == 'phone' || this.rootScopeData.deviceType == 'tablet') {
      this.mobileSelectedCellId = `#cell_${rowIndex}_${colIndex}`;
      this.showMobileEqDetails();
      return false;
    }
    this.showEqDetails = false;
    this.curElement = <HTMLElement>event.currentTarget;
    const curElementCssClasses = this.curElement.classList.toString();
    this.originalCellHeight = this.curElement.offsetHeight;
    this.originalCellWidth = this.curElement.offsetWidth;
    if (curElementCssClasses.indexOf('Icon') === -1 || curElementCssClasses.indexOf('block_Icon') >= 0) {
      this.isHeatmapDragStarted = false;
      return false;
    }
    this.draggedItemRowId = null;
    this.draggedItemColId = null;

    //
    this.cellCloneWidth = this.curElement.offsetWidth;
    this.cellCloneHeight = this.curElement.offsetHeight;

    /*  let totalCellWidthTillColIndex = 0;
    for (let i = 0; colIndex > i; i++) {
      totalCellWidthTillColIndex += $("#"+"cell_" + rowIndex + "_" + i).width();
    }*/
    this.cellLeft = this.originalCellWidth * colIndex;
    this.cellTop = rowIndex * this.originalCellHeight;

    this.isHeatmapDragStarted = true;
    this.initialMouseX = event.clientX;
    this.initialMouseY = event.clientY;
    return true;
  }

  heatMapDragMove(event: DragEvent) {
    if (this.isHeatmapDragStarted) {
      this.isHeatmapCellDragged = true;
      this.currentMouseX = event.clientX;
      this.currentMouseY = event.clientY;
      this.newCellLeft = this.cellLeft - (this.initialMouseX - this.currentMouseX);
      this.newCellTop = this.cellTop - (this.initialMouseY - this.currentMouseY);
      const cloneEle = <HTMLElement>this.curElement.querySelector('.clone');
      cloneEle.classList.add('show');
      cloneEle.style.width = `${this.curElement.style.width} !important`;
      this.findTargetCell(event);
    }
  }

  findTargetCell(e: { clientX: number; clientY: number }) {
    const heatMapTableTop = $('#heatMapTable').offset().top;
    const heatMapTableLeft = $('#heatMapTable').offset().left;
    let currentMouseX = 0;
    let currentMouseY = 0;
    let mouseTop = 0;

    currentMouseX = e.clientX;
    currentMouseY = e.clientY;
    mouseTop = currentMouseY + $(window).scrollTop();

    const mouseLeftOnHeatMapTable = currentMouseX - heatMapTableLeft;
    const mouseTopOnHeatMapTable = mouseTop - heatMapTableTop;

    this.droppableColIndex = Math.floor(mouseLeftOnHeatMapTable / this.originalCellWidth);
    this.droppableRowIndex = Math.floor(mouseTopOnHeatMapTable / this.originalCellHeight);
  }

  heatMapDragEnd(event: DragEvent, colIndex: number, rowIndex: number, cellObj: HeatmapColumnObject) {
    if (this.rootScopeData.deviceType == 'phone' || this.rootScopeData.deviceType == 'tablet') {
      return false;
    }
    if (this.isHeatmapDragStarted) {
      this.isHeatmapDragStarted = false;
      if (!this.isHeatmapCellDragged) {
        return false;
      }
      this.isHeatmapCellDragged = false;
      this.sourceRowId = this.floorsList[this.activeFloorIndex].floorDetails[rowIndex].rowId;
      this.sourceColId = cellObj.columnId;
      this.targetRowId = this.floorsList[this.activeFloorIndex].floorDetails[this.droppableRowIndex].rowId;
      this.targetColId =
        this.floorsList[this.activeFloorIndex].floorDetails[this.droppableRowIndex].columns[
          this.droppableColIndex
        ].columnId;
      const inputJson: IMoveEquipmentInputVO = {
        facilityId: this.currentFacility.facilityId,
        floorId: this.selectedFloorId,
        fromRowId: this.sourceRowId,
        fromColumnId: this.sourceColId,
        toRowId: this.targetRowId,
        toColumnId: this.targetColId,
      };
      if (cellObj.isStrengthAsset == 'true') {
        inputJson.isStrengthAsset = cellObj.isStrengthAsset;
        inputJson.strengthAssetId = cellObj.strengthAssetId;
      } else {
        inputJson.assetId = cellObj.assetId;
      }
      this._amplitudeService.logEvent({ elementName: 'Move Equipment', action: 'Click' }, 'Heatmap');
      this.dashboardService.moveEquipment(inputJson).subscribe(
        (data) => {
          cellObj.columnId = this.targetColId;
          this.floorsList[this.activeFloorIndex].floorDetails[this.droppableRowIndex].columns[this.droppableColIndex] =
            cellObj;
          const cloneEle = <HTMLElement>this.curElement.querySelector('.clone');
          cloneEle.classList.remove('show');

          const emptyCellObj = {
            columnId: this.sourceColId,
            isBeltWearNotification: 'false',
            isBlock: 'false',
            isConnected: 'false',
            isDataCollected: 'false',
            isEmpty: 'true',
            isRotationComplete: 'false',
            isRotationNotification: 'false',
          };
          this.floorsList[this.activeFloorIndex].floorDetails[rowIndex].columns[colIndex] = emptyCellObj;
        },
        (error) => {
          if (error.error.includes(710)) {
            this.errorModal = true;
            this.cancelHeatMapDragAndDrop();
          }
          console.error('API failed.');
        }
      );
      this.draggedItemRowId = this.sourceRowId;
      this.draggedItemColId = this.sourceColId;
    }
    return true;
  }

  cancelHeatMapDragAndDrop() {
    const cloneEle = <HTMLElement>this.curElement.querySelector('.clone');
    cloneEle.classList.remove('show');
    this.isHeatmapDragStarted = false;
    //  $scope.isHeatmapCellDragged = false;
  }

  deleteHeatMapFloor(e: { stopPropagation: () => void }, floorName: string, floorId: number) {
    //  this.showHeatMapFloorPopup = true;
    this.deleteFloorName = floorName;
    this.deleteFloorId = floorId;
    const title = this.commonUtil.replaceValueAsHTMLOnTranslatedText('DELETE.NO', [this.deleteFloorName]);
    const msg = this.commonUtil.replaceValueAsHTMLOnTranslatedText('DELETE.FLOOR.MSG', [this.deleteFloorName]);
    this.heatMapPopupData = {
      meta: 'delete floor',
      title: title,
      message: msg,
      ctaButtonLabel: 'CANCEL',
      isCloseIconCallsCta: true,
      hideSecondaryButton: false,
      negativeButtonLabel: 'DELETE',
    };
    this.showHeatMapPopup = true;
    e.stopPropagation();
    /*var deleteFloorHeaderTxt = $rootScope.replaceValueAsHTMLOnTranslatedText('DELETE.NO',floorName);
		var deleteFloorTxt = $rootScope.replaceValueOnTranslatedText('DELETE.FLOOR.MSG',floorName);
		$scope.$parent.setPopUpInfo(floorId,deleteFloorHeaderTxt,deleteFloorTxt,$scope.deleteSelectedFloorFromHeatMap);
		$scope.$parent.showDeletePopupOfHeatMap = true;
		$scope.$parent.showConfirmationPopUp();*/
  }

  negativeClickAction() {
    if (this.heatMapPopupData.meta === 'delete floor') {
      this.deleteFloor();
    } else if (this.heatMapPopupData.meta === 'delete row') {
      this.deleteSelectedRow();
      this.closePopup();
    } else if (this.heatMapPopupData.meta === 'delete col') {
      this.deleteSelectedCol();
      this.closePopup();
    }
  }

  deleteFloor() {
    if (this['floorsList'].length > 1) {
      for (let i = 0; i < this.floorsList.length; i++) {
        if (this.floorsList[i].floorId == this.deleteFloorId) {
          this.deletedFloorIndex = i;
          //	$scope.heatMap[i].showFloorSpinner = true;
          break;
        }
      }
      this.closePopup();
      const inputJson: IHeatMapAddDeleteObject = {
        facilityId: this.currentFacility.facilityId,
        floorId: this.floorsList[this.deletedFloorIndex].floorId,
      };
      //  $('#floorBtnSpinner_'+this.deletedFloorIndex).removeClass('hide');
      $('#floorBtnSpinner_' + this.deletedFloorIndex).removeClass('hide');
      this._amplitudeService.logEvent({ elementName: 'Delete Floor', action: 'Click' }, 'Heatmap');
      this.dashboardService.deleteHeatMapGridInfo(inputJson).subscribe(
        (data) => {
          if (this.selectedFloorId === inputJson.floorId) {
            this.changeFloor(0);
            $('#floorBtnSpinner_' + this.deletedFloorIndex).addClass('hide');
          }
          this.floorsList.splice(this.deletedFloorIndex, 1);
          this.floorNameList.splice(this.deletedFloorIndex, 1);
          this.deletedFloorIndex = -1;
          this.enableScrollableFloorButtons();
        },
        (error) => {
          console.error('API failed.');
          $('#floorBtnSpinner_' + this.deletedFloorIndex).addClass('hide');
        }
      );
    }
  }

  closePopup() {
    this.showHeatMapPopup = false;
  }

  renameFloor(e: { stopPropagation: () => void }, ind: number) {
    e.stopPropagation();
    this.renameFloorIndex = ind;
  }

  displayFloorName(e: FocusEvent, ind: number, floorObj: HeatmapFloorListObject) {
    this.renameFloorIndex = -1;
    if (floorObj.floorName === '') {
      floorObj.floorName = this.floorNameList[ind];
      return false;
    } else {
      const inputJson: IHeatMapAddDeleteObject = {
        facilityId: this.currentFacility.facilityId,
        floorId: floorObj.floorId,
        floorName: floorObj.floorName,
      };
      $('#floorBtnSpinner_' + ind).removeClass('hide');
      this.dashboardService.saveHeatMapGridInfo(inputJson).subscribe(
        (data) => {
          $('#floorBtnSpinner_' + ind).addClass('hide');
          this.floorNameList[ind] = floorObj.floorName;
        },
        (error) => {
          console.error('API failed.');
          $('#floorBtnSpinner_' + ind).addClass('hide');
        }
      );
    }
    return true;
  }

  localizeDate(t: string | number | Date | any) {
    if (t == null) return '';
    const monNames = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];
    if (!isNaN(t)) t = parseInt(t);
    const d = new Date(t);
    const hours = d.getHours() < 10 ? '0' + d.getHours() : d.getHours(); //hours in military time format
    const mins = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();
    const transMth = 'MTH.' + monNames[d.getMonth()];
    //  alert(this.commonUtil.translateText(transMth));
    let formatteddate;
    if (this.rootScopeData.preferredLanguage == 'ar' || this.rootScopeData.preferredLanguage == 'he') {
      formatteddate =
        d.getDate() + ' ' + this.commonUtil.translateText(transMth) + ' ' + d.getFullYear() + ', ' + hours + ':' + mins; //Removed AM and PM (military time)
    } else if (this.rootScopeData.preferredLanguage == 'zhl') {
      formatteddate =
        d.getFullYear() +
        this.commonUtil.translateText('YEAR') +
        (d.getMonth() + 1) +
        this.commonUtil.translateText('MONTH') +
        d.getDate() +
        this.commonUtil.translateText('DATE.FORMAT'); //Removed AM and PM (military time)
    } else {
      formatteddate =
        this.commonUtil.translateText(transMth) +
        ' ' +
        d.getDate() +
        ', ' +
        d.getFullYear() +
        ', ' +
        hours +
        ':' +
        mins; //Removed AM and PM (military time)
    }
    //  alert(formatteddate)
    return formatteddate;
  }

  getModelName(eqDetails: HeatmapColumnObject) {
    if (!eqDetails) return '';
    let eqType;
    const type = eqDetails.consoleType;
    if (type == 'discover') {
      eqType = 'Discover';
    } else if (type == 'aquaman') {
      eqType = 'Discover SE3';
    } else if (type == 'superman') {
      eqType = 'Discover SE3 HD';
    } else if (type == 'hercules') {
      eqType = 'Integrity X';
    } else if (type == 'duplo') {
      eqType = 'Integrity C';
    } else if (type == 'explore' || type == 'explorer') {
      eqType = 'Explore';
    } else if (type == 'integrity') {
      eqType = 'Integrity';
    } else if (type == 't1') {
      eqType = '50L';
    } else if (type == 'bluth') {
      eqType = 'Discover ST';
    } else if (type == 'mulder') {
      eqType = 'Cybex 70T';
    } else if (type == 'icg') {
      eqType = 'WattRate TFT';
    } else if (type == 't3') {
      eqType = 'T3';
    } else if (type == 'munchkin') {
      eqType = 'Munchkin';
    } else if (type == 'activate') {
      eqType = 'Activate';
    } else if (type == 'Cybex625A') {
      eqType = 'Cybex 625A';
    } else if (type == 'ot') {
      eqType = 'Discover OT';
    } else if (type == 'hal') {
      eqType = 'Discover SE4';
    } else if (type == 'neo') {
      eqType = 'Aspire SL';
    } else if (type == 'neo_se4') {
      eqType = 'Aspire SE4';
    } else if (type == 'falco') {
      eqType = 'Integrity SE4';
    } else if (type == 'everest') {
      eqType = 'Symbio';
    } else if (eqDetails.isStrengthAsset === 'true') {
      eqType = this.commonUtil.translateText(`EQ.TYPE.${eqDetails.activityId}${eqDetails.machineModelId}.SINGULAR`);
    }
    return eqType;
  }

  positionRowColDeleteBtn(
    event: { currentTarget: HTMLElement },
    rowIndex: number,
    colIndex: number,
    cellObj: HeatmapColumnObject
  ) {
    if (!this.rowDeleteInProgress && !this.colDeleteInProgress) {
      const el = event.currentTarget;

      this.deleteRowTop = el.offsetTop;
      this.deleteRowHeight = el.offsetHeight + 1;
      this.deleteColLeft = el.offsetLeft - this.scrollAmount * el.offsetWidth;
      this.deleteColWidth = el.offsetWidth + 1;
      this.rowIndexToDelete = rowIndex;
      this.colIndexToDelete = colIndex;
      if (this.heatMapOffsetTop === 0) {
        this.heatMapOffsetTop = $('#heatMapTableScrollContainer').offset().top + 73;
      }
    }

    if (cellObj.isEmpty == 'false' && cellObj.isBlock == 'false') {
      /*	if($(event.target).hasClass('heatMapCell')){
				var currentCellTopValue =$(event.target).position().top;
				var currentCellLeftValue = $(event.target).position().left;
				var currentCell =  $(event.target);
			}else{
				var currentCellTopValue =$(event.target).closest('.heatMapCell').position().top;
				var currentCellLeftValue = $(event.target).closest('.heatMapCell').position().left;
				var currentCell =  $(event.target).closest('.heatMapCell');
			}*/
      //	$scope.hidePendingEquipmentListOrDelete();
      if (!this.isHeatmapDragStarted) {
        this.showAddedEquipmentDetails(
          colIndex,
          rowIndex,
          this.deleteRowTop,
          this.deleteColLeft,
          this.deleteRowHeight,
          this.deleteColWidth,
          cellObj
        );
      }
    } else {
      //  $('#addedEqDetailsCntr').addClass("hide");
      this.showEqDetails = false;
    }
  }

  showAddedEquipmentDetails(
    colIndex: number,
    rowIndex: number,
    mouseTop: number,
    mouseLeft: number,
    cellHeight: number,
    cellWidth: number,
    cellObj: HeatmapColumnObject
  ) {
    this.selectedEqDetails = cellObj;
    //  $('#addedEqDetailsCntr').removeClass("hide");
    this.showEqDetails = true;
    //$scope.selectedEqUsage = $scope.getLegendValue(cellObj.hoursUsage, cellObj.isDataCollected);
    this.selectedEqUsage = cellObj.legend;
    this.isConnectedEquipment = false;
    this.isDisconnectedEquipment = false;
    this.isIdleEquipment = false;
    this.isBeltNotification = false;
    this.isRotateNotification = false;
    this.beltNotificationURL = cellObj.maintenanceUrl;
    this.rotateNotificationURL = cellObj.rotationUrl;
    this.rotationSuggestedEquipment = cellObj.rotationWithBodySerial;
    if (cellObj.status == 'C') {
      this.isConnectedEquipment = true;
    } else if (cellObj.status == 'NC') {
      this.isDisconnectedEquipment = true;
    } else if (cellObj.status == 'I') {
      this.isIdleEquipment = true;
    } else if (cellObj.isBeltWearNotification == 'true') {
      this.isBeltNotification = true;
    } else if (cellObj.isRotationNotification == 'true') {
      this.isRotateNotification = true;
    }

    /*const callPositionEqDetailsList = this.positionEqDetailsList;
		window.setTimeout(function(){
			callPositionEqDetailsList(colIndex, rowIndex, mouseTop, mouseLeft, currentCell);
    },50);*/

    this.positionEqDetailsList(colIndex, rowIndex, mouseTop, mouseLeft, cellHeight, cellWidth);
  }

  positionEqDetailsList(
    colIndex: number,
    rowIndex: number,
    cellTop: number,
    cellLeft: number,
    cellHeight: number,
    cellWidth: number
  ) {
    //  alert(this.floorsList.length);
    const totalRowsInHeatMap = this.floorsList[this.activeFloorIndex].floorDetails.length;
    const totalColsInHeatMap = this.floorsList[this.activeFloorIndex].floorDetails[0].columns.length;
    const totalVisibleCols =
      totalColsInHeatMap > this.maxVisibleColPerFloor ? this.maxVisibleColPerFloor : totalColsInHeatMap;
    let leftSpacing = 350;

    const eqDetailsCntrHeight = $('#addedEqDetails').outerHeight() ? $('#addedEqDetails').outerHeight() : 258;
    const eqDetailsCntrWidth = $('#addedEqDetails').outerWidth() ? $('#addedEqDetails').outerWidth() : 200;
    const visibleColIndex = colIndex - this.scrollAmount;

    if (!this.heatMapOffsetTop) {
      this.heatMapOffsetTop = $('#heatMapTableScrollContainer').offset().top + 73;
    }
    if (this.viewHeatMapInFullView) {
      this.heatMapOffsetTop = $('#heatMapTableScrollContainer').offset().top;
      leftSpacing = 60;
    }
    if (Math.ceil(totalVisibleCols / 2) > visibleColIndex && Math.ceil(totalRowsInHeatMap / 2) > rowIndex) {
      // cell is in left top
      this.menuTop = cellTop + this.heatMapOffsetTop;
      this.menuLeft = cellLeft + leftSpacing + cellWidth * 0.5;
      this.beakTop = 20;
      this.isRightToLeftSlideRequired = false;
    } else if (Math.ceil(totalVisibleCols / 2) <= visibleColIndex && Math.ceil(totalRowsInHeatMap / 2) > rowIndex) {
      // cell is in right top
      this.menuTop = cellTop + this.heatMapOffsetTop;
      this.menuLeft = cellLeft + leftSpacing - eqDetailsCntrWidth + cellWidth * 0.5;
      this.beakTop = 20;
      this.isRightToLeftSlideRequired = true;
    } else if (Math.ceil(totalVisibleCols / 2) > visibleColIndex && Math.ceil(totalRowsInHeatMap / 2) <= rowIndex) {
      // cell is in left bottom
      this.menuTop = cellTop + this.heatMapOffsetTop - eqDetailsCntrHeight + cellHeight;
      this.menuLeft = cellLeft + leftSpacing + cellWidth * 0.5;
      this.isRightToLeftSlideRequired = false;
      this.beakTop = eqDetailsCntrHeight - 40;
    } else if (Math.ceil(totalVisibleCols / 2) <= visibleColIndex && Math.ceil(totalRowsInHeatMap / 2) <= rowIndex) {
      // cell is in right bottom
      this.menuTop = cellTop + this.heatMapOffsetTop - eqDetailsCntrHeight + cellHeight;
      this.menuLeft = cellLeft + leftSpacing - eqDetailsCntrWidth + cellWidth * 0.5;
      this.isRightToLeftSlideRequired = true;
      this.beakTop = eqDetailsCntrHeight - 40;
    }
    this.menuLeft = this.menuLeft - cellWidth * this.scrollAmount;
    //  this.hideEqListAndDeleteEqBtn();
    this.hideDeleteMenu();
    this.hidePendingEqList();
  }

  /* hideEqListAndDeleteEqBtn() {
    this.showDeleteEquipment = false;
    this.showPendingEqTypeList = false;
    this.highlightCell = false;
  }
  */

  deleteHeatMapRow() {
    if (!this.rowDeleteInProgress) {
      if (this.isSelectedRowContainsEquipment()) {
        const rowIndex = this.rowIndexToDelete + 1 + '';
        const deleteRowNumber = this.commonUtil.replaceValueAsHTMLOnTranslatedText('ROW.NO', [rowIndex]);

        const title = this.commonUtil.replaceValueAsHTMLOnTranslatedText('DELETE.NO', [deleteRowNumber]);
        const msg = this.commonUtil.replaceValueAsHTMLOnTranslatedText('DELETE.NO.MSG', [deleteRowNumber]);
        this.heatMapPopupData = {
          meta: 'delete row',
          title: title,
          message: msg,
          ctaButtonLabel: 'CANCEL',
          isCloseIconCallsCta: true,
          hideSecondaryButton: false,
          negativeButtonLabel: 'DELETE',
        };
        this.showHeatMapPopup = true;
      } else {
        this.deleteSelectedRow();
      }
    }
  }

  isSelectedRowContainsEquipment() {
    const selectedRow = this.floorsList[this.activeFloorIndex].floorDetails[this.rowIndexToDelete];
    for (let i = 0; selectedRow.columns.length > i; i++) {
      if (selectedRow.columns[i].assetId) {
        return true;
      }
    }
    return false;
  }

  deleteSelectedRow() {
    const currentRowIndexToDelete = this.rowIndexToDelete;
    const inputJson: IHeatMapAddDeleteObject = {
      facilityId: this.currentFacility.facilityId,
      floorId: this.selectedFloorId,
      rowId: this.floorsList[this.activeFloorIndex].floorDetails[currentRowIndexToDelete].rowId,
    };
    const currentFloorDetails = this.floorsList[this.activeFloorIndex].floorDetails;
    this.rowDeleteInProgress = true;
    this._amplitudeService.logEvent({ elementName: 'Delete Row', action: 'Click' }, 'Heatmap');
    this.dashboardService.deleteHeatMapGridInfo(inputJson).subscribe(
      (data) => {
        this.rowDeleteInProgress = false;
        $('#row_' + currentRowIndexToDelete + ' .heatMapCell').addClass('transparentBg');
        $('#row_' + currentRowIndexToDelete).addClass('delete');
        const thisObj = this;
        const numberRows = this.floorsList[this.activeFloorIndex].floorDetails.length;
        window.setTimeout(function () {
          $('#row_' + currentRowIndexToDelete).addClass('collapse');
          window.setTimeout(function () {
            $('#row_' + currentRowIndexToDelete + ' .heatMapCell').removeClass('transparentBg');
            currentFloorDetails.splice(currentRowIndexToDelete, 1);

            if (numberRows > 10) {
              const curHeatmapHeight = parseInt(thisObj.heatMapTableScrollContainerElem.nativeElement.style.height, 10);
              thisObj.heatMapTableScrollContainerElem.nativeElement.style.height = curHeatmapHeight - 51 + 'px';
            }
          }, 500);
        }, 500);
      },
      (error) => {
        console.error('API failed.');
        this.rowDeleteInProgress = false;
      }
    );
  }

  deleteHeatMapCol() {
    if (this.isSelectedColContainsEquipment()) {
      const colIndex = (this.colIndexToDelete + 1).toString();
      const deleteColNumber = this.commonUtil.replaceValueAsHTMLOnTranslatedText('COLUMN.NO', [colIndex]);

      const title = this.commonUtil.replaceValueAsHTMLOnTranslatedText('DELETE.NO', [deleteColNumber]);
      const msg = this.commonUtil.replaceValueAsHTMLOnTranslatedText('DELETE.NO.MSG', [deleteColNumber]);
      this.heatMapPopupData = {
        meta: 'delete col',
        title: title,
        message: msg,
        ctaButtonLabel: 'CANCEL',
        isCloseIconCallsCta: true,
        hideSecondaryButton: false,
        negativeButtonLabel: 'DELETE',
      };
      this.showHeatMapPopup = true;
    } else {
      this.deleteSelectedCol();
    }
  }

  isSelectedColContainsEquipment() {
    const rowList = this.floorsList[this.activeFloorIndex].floorDetails;
    for (let i = 0; rowList.length > i; i++) {
      if (rowList[i].columns[this.colIndexToDelete].assetId) {
        return true;
      }
    }
    return false;
  }

  deleteSelectedCol() {
    const currentColIndexToDelete = this.colIndexToDelete;
    const inputJson: IHeatMapAddDeleteObject = {
      facilityId: this.currentFacility.facilityId,
      floorId: this.selectedFloorId,
      colId: this.floorsList[this.activeFloorIndex].floorDetails[0].columns[currentColIndexToDelete].columnId,
    };

    const rowList = this.floorsList[this.activeFloorIndex].floorDetails;
    this.colDeleteInProgress = true;
    this._amplitudeService.logEvent({ elementName: 'Delete Column', action: 'Click' }, 'Heatmap');
    this.dashboardService.deleteHeatMapGridInfo(inputJson).subscribe(
      (data) => {
        this.colDeleteInProgress = false;
        const requiredInterval = 500 / rowList.length;
        let i = 0;
        $('.heatMapCell.animate').css('transition', requiredInterval + 'ms');
        window.setInterval(function () {
          $('#cell_' + i + '_' + currentColIndexToDelete).addClass('delete');
          i++;
        }, requiredInterval);

        window.setTimeout(function () {
          $('.heatMapCell.animate').css('transition', '500ms');
          for (let i = 0; rowList.length > i; i++) {
            $('#cell_' + i + '_' + currentColIndexToDelete).addClass('collapse');
          }
          window.setTimeout(function () {
            for (let i = 0; rowList.length > i; i++) {
              rowList[i].columns.splice(currentColIndexToDelete, 1);
            }
          }, 500);
        }, 500);
      },
      (error) => {
        console.error('API failed.');
        this.colDeleteInProgress = false;
      }
    );
  }

  showRowColDeleteBtn() {
    this.showRowColDelete = true;
  }

  hideRowColDeleteBtn() {
    this.showRowColDelete = false;
  }

  showLastUsedPeakUseDef() {
    this.showLastUsedDef = true;
    if ($('#addedEqDetails').outerHeight() > $('#lastUsedPeakUseDetails').outerHeight()) {
      $('#lastUsedPeakUseDetails').css('height', $('#addedEqDetails').outerHeight() + 'px');
    } else {
      $('#addedEqDetails').css('height', $('#lastUsedPeakUseDetails').outerHeight() + 'px');
    }
    //	$("#addedEqDetails").addClass("noRightShadow");
  }

  hideLastUsedPeakUseDef() {
    this.showLastUsedDef = false;
    $('#lastUsedPeakUseDetails, #addedEqDetails').css('height', 'auto');
  }

  showMobileEqSubDetails() {
    this.showEqSubDetails_mobile = true;
  }

  hideMobileEqSubDetails() {
    this.showEqSubDetails_mobile = false;
  }

  showMobileEqDetails() {
    this.showEqDetails_mobile = true;
    this.toggle = true;
    $('.mobile-selected-cell').removeClass('mobile-selected-cell');
    $(this.mobileSelectedCellId).addClass('mobile-selected-cell');
  }

  hideMobileEqDetails() {
    this.showEqDetails_mobile = false;
    this.toggle = false;
    this.hideMobileEqSubDetails();
    $(this.mobileSelectedCellId).removeClass('mobile-selected-cell');
  }

  showLastUsedMsg(e: { stopPropagation: () => void }) {
    this.showLastUsedTooltip = true;
    e.stopPropagation();
  }

  hideLastUsedMsg() {
    this.showLastUsedTooltip = false;
  }

  showPeakUseMsg(e: { stopPropagation: () => void }) {
    this.showPeakUseTooltip = true;
    e.stopPropagation();
  }

  hidePeakUseMsg() {
    this.showPeakUseTooltip = false;
  }

  closeAllMachinesAddedPopup() {
    this.isAllMachinesAdded = false;
  }

  stopBubbling(e: { stopPropagation: () => void }) {
    e.stopPropagation();
  }

  ngAfterViewInit() {
    this.enableScrollableFloorButtons();
    setTimeout(() => {
      if (
        document.querySelector('.heatMapOuterCntr--web') &&
        localStorage.getItem('showHeatMapSection') &&
        this.rootScopeData.deviceType === 'pc'
      ) {
        const _elemHMC = <HTMLElement>document.querySelector('app-heatmap #heatMapOuterCntr');

        if (this.commonUtil.isBrowser() === 'safari') {
          const _elem = <HTMLElement>document.querySelector('#page-cntr');
          _elem.scrollTo({ top: _elemHMC.getBoundingClientRect().top - 150 });
        } else if (this.commonUtil.isBrowser() === 'chrome') {
          _elemHMC.scrollIntoView({ behavior: 'smooth' });
        } else {
          _elemHMC.scrollIntoView();
        }
        localStorage.setItem('showHeatMapSection', '');
      }
    }, 5000);
  }

  cloneStyle(cellWidth: number, newCellLeft: number, newCellTop: number) {
    return `width:${cellWidth}px !important; left:${newCellLeft}${newCellLeft == 0 ? '' : 'px'}; top:${newCellTop}${
      newCellTop == 0 ? '' : 'px'
    }`;
    // return 'width:' + cellWidth + ' !important;left:' + newCellLeft + 'px;top:' + newCellTop + 'px';
  }

  getTopPositionOfDeleteRowCntr() {
    if (this.floorsList[this.activeFloorIndex].floorDetails.length === 9) {
      const correctionIndex = this.rowIndexToDelete > 0 ? this.rowIndexToDelete / 3 + 1 : 0;
      return !this.viewHeatMapInFullView
        ? this.heatMapOffsetTop - 72 + this.rowIndexToDelete * this.deleteRowHeight - correctionIndex
        : $('#heatMapTableScrollContainer').offset()?.top +
            this.rowIndexToDelete * this.deleteRowHeight -
            correctionIndex;
    }
    return !this.viewHeatMapInFullView
      ? this.heatMapOffsetTop - 73 + this.rowIndexToDelete * (this.deleteRowHeight - 1)
      : $('#heatMapTableScrollContainer').offset()?.top + this.rowIndexToDelete * (this.deleteRowHeight - 1);
  }

  private gotoStatsPage(status: string) {
    localStorage.setItem('quickFilterStatus', status);
    this.router.navigateByUrl('/stats');
  }

  nameOne(event: any, pendingEq: any) {
    console.log('Heat Map Add name');
    pendingEq.nameEditable = true;
    event.stopPropagation();
  }

  onFocusIn(event: any, pendingEq: any) {
    console.log('---input focus---');
    this.actionStatus = 'inputFocusIn';
    pendingEq.originalName = pendingEq.name;
  }

  onFocusOut(event: any, pendingEq: any) {
    console.log('---input focus out---');
    this.actionStatus = 'inputFocusOut';
    if (pendingEq.name.trim() !== '') {
      this.nameAllUpdate(pendingEq);
    } else {
      pendingEq.name = pendingEq.originalName;
    }
  }

  onKeyPress(event: any, pendingEq: any) {
    console.log('---pending Eq---', pendingEq);
    this.actionStatus = 'inputFocusOut';
    if (event.key === 'Enter') {
      if (pendingEq.name.trim() !== '') {
        this.nameAllUpdate(pendingEq);
      } else {
        pendingEq.name = pendingEq.originalName;
      }
    }
  }

  async nameAllUpdate(pendingEq: any) {
    if (pendingEq.name ? pendingEq.name.trim() : '' !== pendingEq.originalName ? pendingEq.originalName.trim() : '') {
      try {
        this.loader.startProcess();
        const resp = await this._equipmentService
          .nameEquipment(
            pendingEq.facilityId,
            pendingEq.bodySerial,
            pendingEq.name,
            pendingEq.equipmentType,
            pendingEq.equipmentModel,
            pendingEq.assetId,
            pendingEq.id
          )
          .toPromise();
        this.loader.endProcess();
        this._toast.creatToast(this.commonUtil.translateText('UPDATED.EQUIPMENT'));
        pendingEq.nameEditable = false;
      } catch (error) {
        let errorCode;
        const errorMessage = error?.error;
        if (typeof errorMessage !== 'object') {
          errorCode = errorMessage.substring(errorMessage.indexOf('Code: ') + 6, errorMessage.indexOf('Code: ') + 9);
        } else {
          errorCode = errorMessage?.errorCode;
        }

        console.log(error);
        this.loader.endProcess();
      }
    } else {
      pendingEq.nameEditable = false;
    }
  }

  addEquipmentToHeatMap(event: MouseEvent, ind: number, equipmentDetailsObj: heatmapAsset) {
    event.stopPropagation();
    if (this.actionStatus !== 'inputFocusIn') {
      const inputJson: IHeatMapAddDeleteEquipmentObject = {
        facilityId: this.currentFacility.facilityId,
        floorId: this.selectedFloorId,
        rowId: this.selectedRowId,
        columnId: this.selectedColId,
        isBlock: 'false',
      };
      if (equipmentDetailsObj.activityId == this._strengthActivityId) {
        inputJson.isStrengthAsset = 'true';
        inputJson.strengthAssetId = equipmentDetailsObj.assetId;
      } else {
        inputJson.assetId = equipmentDetailsObj.id;
      }
      $('#pendingEq_' + ind + ' .eq-icon').addClass('hide');
      $('#pendingEq_' + ind + ' .equipmentListCell > img').addClass('hide');
      $('#pendingEq_' + ind).addClass('active');
      this._amplitudeService.logEvent({ elementName: 'Add Equipment', action: 'Click' }, 'Heatmap');
      this.dashboardService.addEquipment(inputJson).subscribe(
        (data) => {
          window.setTimeout(() => {
            $('#pendingEq_' + ind).removeClass('active');
            $('#pendingEq_' + ind).addClass('added');
            $('#pendingEq_' + ind)
              .find('.addedMsg')
              .removeClass('hide');
            window.setTimeout(() => {
              $('#pendingEq_' + ind).removeClass('added animate');
              $('#pendingEq_' + ind + ' .eq-icon').removeClass('hide');
              $('#pendingEq_' + ind + ' .addedIcon').css('backgroundImage', '');
              window.setTimeout(() => {
                $('#pendingEq_' + ind).addClass('animate1000 remove');
                $('.pendingEquipmentTypeRow.highlightGray span').addClass('changeBg');

                if (this.selectedEquipmentType.assets && this.selectedEquipmentType.assets.length === 1) {
                  window.setTimeout(() => {
                    $('.pendingEquipmentTypeRow.highlightGray')
                      .not('.allMachinesAdded')
                      .find('.drawer')
                      .addClass('drawerOn');
                    window.setTimeout(() => {
                      $('.pendingEquipmentTypeRow.highlightGray .drawer').removeClass('animate drawerOn');
                      $('.pendingEquipmentTypeRow.highlightGray').addClass('disabled');
                      $('.pendingEquipmentTypeRow.highlightGray .pendingEquipmentCount').addClass('hide');
                      window.setTimeout(() => {
                        $('.pendingEquipmentTypeRow.highlightGray .txt span').removeClass('hide');
                        this.hideMenuAndShowPopup(data.value);
                      }, 500);
                    }, 500);
                  }, 500);
                } else {
                  this.hideMenuAndShowPopup(data.value);
                }
              }, 500);
            }, 500);
          }, 500);

          const newEquipmentObject: HeatmapColumnObject = {
            activityId: equipmentDetailsObj.activityId,
            bodySerial: equipmentDetailsObj.bodySerial,
            columnId: this.selectedColId,
            consoleType: equipmentDetailsObj.consoleType,
            isBlock: 'false',
            isDataCollected: 'false',
            isEmpty: 'false',
            legend: '',
            icon: 'eq_' + this.selectedEquipmentType.activityId + '_IconWithTimer',
            iconClass: 'IconWithTimer',
            displayName: equipmentDetailsObj.name,
            displayBodySerial: equipmentDetailsObj.displaySerial,
            machineModelId: equipmentDetailsObj.machineModelId,
          };
          if (equipmentDetailsObj.activityId == this._strengthActivityId) {
            newEquipmentObject.isStrengthAsset = 'true';
            newEquipmentObject.strengthAssetId = equipmentDetailsObj.id;
          } else {
            newEquipmentObject.assetId = equipmentDetailsObj.id;
          }
          this.floorsList[this.activeFloorIndex].floorDetails[this.selectedRowIndex].columns[this.selectedColIndex] =
            newEquipmentObject;
          //  this.showPendingEqTypeList = false;
          this.highlightCell = false;
        },
        (error) => {
          if (error.error.includes(705)) {
            this.errorModal = true;
          }
          if (error.error.includes(709)) {
            this.errorModal = true;
          }
          this.showPendingEqTypeList = false;
          this.highlightCell = false;
          console.error('API failed.');
        }
      );
    }
  }

  refreshModal() {
    this.errorModal = false;
    window.location.reload();
  }
  closeModal() {
    this.errorModal = false;
  }
}
